import React from 'react';

function fmt(d) {
  if (!d) return '–';
  return new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function EventBasicInfo({ event }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="card">
        <p className="section-title">Termine</p>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between"><dt className="text-slate-500">Start</dt><dd className="font-medium">{fmt(event.start_date)}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-500">Ende</dt><dd className="font-medium">{fmt(event.end_date)}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-500">Ort</dt><dd className="font-medium">{event.location ? <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.location)}`} target="_blank" rel="noopener noreferrer" className="text-ocean-600 hover:underline">{event.location}</a> : '–'}</dd></div>
        </dl>
      </div>
      <div className="card">
        <p className="section-title">Tickets</p>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between"><dt className="text-slate-500">Preis</dt><dd className="font-bold text-sand-700">{event.ticket_price ? `${parseFloat(event.ticket_price).toFixed(2)} €` : 'Kostenlos'}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-500">Verfügbar</dt><dd className="font-medium">{event.max_participants != null ? Math.max(0, event.max_participants - (event.tickets_sold || 0)) : '∞'} / {event.max_participants ?? '∞'}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-500">Verkauf ab</dt><dd className="font-medium">{fmt(event.ticket_sale_start)}</dd></div>
          <div className="flex justify-between"><dt className="text-slate-500">Verkauf bis</dt><dd className="font-medium">{fmt(event.ticket_sale_end)}</dd></div>
        </dl>
      </div>
      {event.description && (
        <div className="card sm:col-span-2">
          <p className="section-title">Beschreibung</p>
          <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">{event.description}</p>
        </div>
      )}
    </div>
  );
}

export function EventTextBlock({ event, field, label, showLabel = true }) {
  return (
    <div className="card">
      {showLabel && <p className="section-title">{label}</p>}
      <pre className="text-sm text-slate-700 whitespace-pre-wrap font-sans leading-relaxed">
        {event[field] || `Kein ${label} hinterlegt.`}
      </pre>
    </div>
  );
}
